import React from 'react';
import ScanPlateDetailsContainer from './ScanPlateDetailsContainer';
import { ScanPlateConnectorApollo, withMobileAppMode } from '@front-activerse/common-components';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const ScanPlateDetailsPage: React.FC<{ mobileAppMode: boolean; fromUserMeals?: boolean }> = ({
  mobileAppMode,
  fromUserMeals,
}) => {
  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess === 'true' || mobileAppMode) {
    return (
      <ScanPlateConnectorApollo>
        {({ scanPlate, cancelScanPlate }) => (
          <ScanPlateDetailsContainer
            scanPlate={scanPlate}
            cancelScanPlate={cancelScanPlate}
            fromUserMeals={fromUserMeals}
          />
        )}
      </ScanPlateConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default withMobileAppMode(ScanPlateDetailsPage);
